import styled from '@emotion/styled'
import { useLocation, useMatch } from 'react-router-dom'
import { StyledHTMLElement } from 'shop/theme/types'
import { useConsumerCart, useShop } from 'shop/hooks'
import { getFulfillmentFlags } from 'shop/utils'

import { humaniseParam } from './utils'

export const ShopBreadcrumbs = () => {
  const { currentPartnerStore, partner } = useShop()
  const { name: storeName } = currentPartnerStore || {}
  const { cart } = useConsumerCart()
  const storeMatch = useMatch('/store/:store')
  const productMatch = useMatch('/store/:store/:product')
  const location = useLocation()
  const { state } = location

  const { isOrderAtTable } = getFulfillmentFlags(cart?.fulfillment.type)

  const landingPageLink = isOrderAtTable
    ? `/order/table/${cart?.store.slug}`
    : '/order'

  if (!partner?.name || !storeName) return <></>

  const productName =
    state?.product?.name || humaniseParam(productMatch?.params?.product)
  const isProductPage = storeMatch && productName

  return (
    <ShopBreadcrumbsContainer
      data-testid='shop-breadcrumbs'
      vocab='https://schema.org/'
      typeof='BreadcrumbList'
    >
      <li property='itemListElement' typeof='ListItem'>
        <BreadcrumbA property='item' typeof='WebPage' href={landingPageLink}>
          <span property='name'> {partner?.name} </span>
        </BreadcrumbA>
        <meta property='position' content='1'></meta>
      </li>

      <BreadcrumbSpan> / </BreadcrumbSpan>

      <li property='itemListElement' typeof='ListItem'>
        {isProductPage ? (
          <BreadcrumbA
            property='item'
            typeof='WebPage'
            href={`/order${storeMatch.pathname}`}
          >
            <span property='name'> {storeName} </span>
          </BreadcrumbA>
        ) : (
          <BreadcrumbSpan property='name'> {storeName} </BreadcrumbSpan>
        )}
        <meta property='position' content='2'></meta>
      </li>

      {isProductPage && (
        <>
          <BreadcrumbSpan> / </BreadcrumbSpan>
          <li property='itemListElement' typeof='ListItem'>
            <BreadcrumbSpan property='name'> {productName} </BreadcrumbSpan>
            <meta property='position' content='3'></meta>
          </li>
        </>
      )}
    </ShopBreadcrumbsContainer>
  )
}

const Grey = { color: '#8C8C8C' }

const BreadcrumbA = styled.a(() => ({
  ...Grey,
  textDecoration: 'none'
}))

const BreadcrumbSpan = styled.span(() => ({
  ...Grey
}))

const ShopBreadcrumbsContainer = styled.ol<StyledHTMLElement>(({ theme }) => ({
  margin: 0,
  marginTop: '24px',
  fontSize: '12px',
  padding: '0 16px',
  listStyleType: 'none',
  display: 'flex',
  gap: '5px',
  [theme.mediaQueries.viewport7]: {
    padding: '0'
  }
}))
